import { useAuthStore } from '@/features/auth/store/auth-store';
import { authService } from '@/features/auth/services/auth-service';
import { useOnboardingStore } from '@/features/onboarding/store/onboarding-store';
import type { User } from '@/features/auth/types/auth.types';

/**
 * Decisión de Sebastián (2-nov): una empresa que pasa de demo a plan completo NO ve la
 * bienvenida genérica. El servidor marca el onboarding de sus personas al convertir (por
 * cualquier camino); la pantalla se entera volviendo a pedir `/auth/me`, porque el canje de
 * portal no trae `onboardingCompleted`. Sólo cuenta lo que dice el servidor: si no la marcó,
 * acá no se inventa. Soporte («Entrar como») no toca la bienvenida de la persona.
 */
export async function sincronizarBienvenidaTrasConvertir(): Promise<void> {
  if (useAuthStore.getState().isImpersonating) return;
  try {
    const yo = await authService.getCurrentUser();
    if (!(yo as { onboardingCompleted?: boolean }).onboardingCompleted) return;
    useOnboardingStore.setState({ completed: true });
    const { user, setUser } = useAuthStore.getState();
    if (user) setUser({ ...user, onboardingCompleted: true } as User);
  } catch {
    // Sin respuesta, la bienvenida sigue esperando su turno: el próximo /me lo corrige.
  }
}
